import { getInboundAddressDataForChain } from '../getInboundAddressDataForChain';
import { getDaemonUrl } from '../index';
export const getThorTxData = async ({ sellAsset, config, swapperName, }) => {
    const daemonUrl = getDaemonUrl(config, swapperName);
    const res = await getInboundAddressDataForChain(daemonUrl, sellAsset.assetId, false, swapperName);
    if (res.isErr())
        throw res.unwrapErr();
    const { address: vault } = res.unwrap();
    return { vault };
};
